import { LOGO_URL } from "../constants";

const Footer = () => {
  return (
    <footer className="bg-[#0A2540] border-t border-white/10 py-8">
      <div className="max-w-7xl mx-auto px-5 md:px-12">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Lakeze 人客多" className="h-8 w-auto brightness-0 invert" />
          </div>
          <div className="text-white/60 text-sm">
            © {new Date().getFullYear()} 人客多品牌管理. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
